import Minus from "@aus/Assets/Icons/Minus";
import { productListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import Plus from "@insite/mobius/Icons/Plus";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.accordionSection = {
    headerProps: {
        css: css`
            button {
                background: ${getColor("primary.main")} 0% 0% no-repeat padding-box;
            }
        `,
    },
    titleTypographyProps: {
        color: "primary.contrast",
    },
    toggleIconProps: {
        color: "primary.contrast",
        src: Plus,
        size: 26,
    },
    collapseIconProps: {
        color: "primary.contrast",
        src: Minus,
        size: 26,
    },
    expandIconProps: {
        color: "primary.contrast",
        src: Plus,
        size: 26,
    },
};

productListFilterAccordionSectionStyles.checkBoxSelected = {
    color: "secondary.main",
};

productListFilterAccordionSectionStyles.checkBoxGroup = {
    css: css`
        width: 100%;
        padding-bottom: 0px;
        > legend:empty {
            display: none !important;
        }
    `,
};
